export const ENUM_LOGIN = {
    LOGIN: 1,
    CREATE_ACCOUNT: 2,
    RECOVER_PASSWORD: 3,
}

export const ENUM_CREATE_ACCOUNT = {
    FORM: 1,
    SECURITY_CODE: 2,
}